import { BaseEntity, Entity as DecribeEntity, Relation } from '@avangard/utils/entity';

import { FileInfoEntity } from '@modules/shared/entities';
import { SoaDocumentFileVariant } from '@modules/types/graphql';

import type { StudentOnlineApplicationDocumentFile } from '@modules/types/graphql';

export type Entity = Partial<StudentOnlineApplicationDocumentFile> | null;

@DecribeEntity('SoaDocumentFileEntity')
class SoaDocumentFileEntity extends BaseEntity {
    variant: SoaDocumentFileVariant;
    documentRef: boolean;
    documentRefTitle: string;
    documentRefChosenTitle: string;
    uploadTitle: string;

    @Relation(() => FileInfoEntity)
    file: FileInfoEntity;

    constructor(entity: Entity) {
        super(entity);

        this.variant = entity?.variant ?? SoaDocumentFileVariant.primary;
        this.uploadTitle = entity?.uploadTitle ?? '';
        this.documentRef = entity?.documentRef ?? false;
        this.documentRefTitle = entity?.documentRefTitle ?? '';
        this.documentRefChosenTitle = entity?.documentRefChosenTitle ?? '';
    }
}

export { SoaDocumentFileEntity };
